import React, { useState, Suspense, lazy } from 'react';
import './App.css';

import { NotificationProvider } from './Context/NotificationContext';
import { ThemeProvider } from './Context/ThemeContext';
import { AuthProvider, useAuth } from './Context/AuthContext';
import { RealTimeProvider } from './Context/RealTimeContext';
import { ConfirmProvider } from './Context/ConfirmContext';
import { PremiumLoader } from './Components/Common/PremiumLoading';
import ErrorBoundary from './Components/Common/ErrorBoundary';
import BackendReconnectOverlay from './Components/Common/BackendReconnectOverlay';

const Admin_page = lazy(() => import('./Pages/Admin_page/Admin_page'));
const Login_page = lazy(() => import('./Pages/Login_page/Login_page'));

function AppContent() {
  const { isAuthenticated, login, logout } = useAuth();

  const handleLoginSuccess = (token, user, refreshToken) => {
    login(token, user, refreshToken);
  };

  const handleLogoutSuccess = () => {
    logout();
  };

  if (isAuthenticated) {
    return (
      <div className="App">
        <Suspense fallback={<PremiumLoader title="Loading Admin Workspace" subtitle="Preparing modules and real-time context..." className="min-h-[420px]" />}>
          <Admin_page onLogout={handleLogoutSuccess} />
        </Suspense>
      </div>
    );
  }

  return (
    <div className="App">
      <Suspense fallback={<PremiumLoader tone="auth" title="Loading Authentication" subtitle="Setting up secure sign-in experience..." className="min-h-[420px]" />}>
        <Login_page onLogin={handleLoginSuccess} />
      </Suspense>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <RealTimeProvider>
            <NotificationProvider>
              <ConfirmProvider>
                <BackendReconnectOverlay />
                <AppContent />
              </ConfirmProvider>
            </NotificationProvider>
          </RealTimeProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
